/* 
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React, {
  useCallback,
  useEffect,
  useRef
} from 'react';
import {useDispatch} from 'react-redux';
import useHasMounted from '@ion/core/src/hooks/useHasMounted';
import {GenericObject, JobStatus} from '@ion/core/src/types/entities';
import {JobInfoPanel} from './JobInfoPanel';
import {TaskStatusGridEmailProps} from './JobStatusDrawer';
import JobViewDialog from './JobViewDialog';
import {initializeTaskStatus, showJobStatus} from './state';
import TaskStatusGrid from './TaskStatusGrid';

export interface ViewJobStatusProps extends TaskStatusGridEmailProps {
  jobStatus?: JobStatus;
  open?: boolean;
};

/**
 * Display View Device Editor on click on view option from grid menu
 */
export const ViewJobStatus = ({
  jobStatus,
  open = false,
  hasEmailExport = false
}: ViewJobStatusProps) => {
  const gridRefs  = useRef<GenericObject>();
  const isMounted = useHasMounted();
  const dispatch  = useDispatch();

  useEffect(() => {
    if (!isMounted) {
      dispatch(initializeTaskStatus());
    }
  }, [isMounted]);

  const onCancel = useCallback(() => {
    dispatch(showJobStatus(null, false));
  }, [dispatch]);

  return (
    <JobViewDialog open={open}
      onCloseDialog={onCancel}
      jobStatus={jobStatus}>
      <JobInfoPanel jobStatus={jobStatus} />
      <TaskStatusGrid ref={gridRefs}
        hasEmailExport={hasEmailExport}
        jobStatus={jobStatus} />
    </JobViewDialog>
  );
};

export default ViewJobStatus;
